// src/components/NewRealEstate.js
import React, { useState } from "react";
import styled from "styled-components";
import axios from "axios";

const estateTypes = [
  "Land",
  "Agriculture Land",
  "Commercial Building",
  "Residential Building",
  "Apartment",
  "Villa",
  "Duplex House",
  "Office",
  "Shop"
];

const saudiCities = [
  { en: "Abha", ar: "أبها" },
  { en: "Abqaiq", ar: "بقيق" },
  { en: "Abu Arish", ar: "أبو عريش" },
  { en: "Ad Dilam", ar: "الدلم" },
  { en: "Ad Darb", ar: "الدرب" },
  { en: "Ad Dawadimi", ar: "الدوادمي" },
  { en: "Afif", ar: "عفيف" },
  { en: "Ahad Rifaydah", ar: "أحد رفيدة" },
  { en: "Ain Dar", ar: "عين دار" },
  { en: "Al Aflaj", ar: "الأفلاج" },
  { en: "Al Ahsa (Hofuf)", ar: "الأحساء (الهفوف)" },
  { en: "Al Ardah", ar: "العارضة" },
  { en: "Al Artawiyah", ar: "الأرطاوية" },
  { en: "Al Awamiyah", ar: "العوامية" },
  { en: "Al Badayea", ar: "البدائع" },
  { en: "Al Bahah", ar: "الباحة" },
  { en: "Al Batin", ar: "الباطن" },
  { en: "Al Bukayriyah", ar: "البكيرية" },
  { en: "Al Dair", ar: "الدائر" },
  { en: "Al Dayer", ar: "الدائر" },
  { en: "Al Ghat", ar: "الغاط" },
  { en: "Al Hada", ar: "الهدا" },
  { en: "Al Hait", ar: "الحائط" },
  { en: "Al Hassa", ar: "الأحساء" },
  { en: "Al Hufuf", ar: "الهفوف" },
  { en: "Al Jamum", ar: "الجموم" },
  { en: "Al Jawf", ar: "الجوف" },
  { en: "Al Jubail", ar: "الجبيل" },
  { en: "Al Kamil", ar: "الكامل" },
  { en: "Al Khafji", ar: "الخفجي" },
  { en: "Al Kharj", ar: "الخرج" },
  { en: "Al Khobar", ar: "الخبر" },
  { en: "Al Khurmah", ar: "الخرمة" },
  { en: "Al Lith", ar: "الليث" },
  { en: "Al Majmaah", ar: "المجمعة" },
  { en: "Al Mandak", ar: "المندق" },
  { en: "Al Mithnab", ar: "المذنب" },
  { en: "Al Muwayh", ar: "المويه" },
  { en: "Al Namas", ar: "النماص" },
  { en: "Al Omran", ar: "العمران" },
  { en: "Al Qaisumah", ar: "القيصومة" },
  { en: "Al Qatif", ar: "القطيف" },
  { en: "Al Qurayyat", ar: "القريات" },
  { en: "Al Quwayiyah", ar: "القويعية" },
  { en: "Al Rass", ar: "الرس" },
  { en: "Al Shinan", ar: "الشنان" },
  { en: "Al Sulayyil", ar: "السليل" },
  { en: "Al Tuwal", ar: "الطوال" },
  { en: "Al Ula", ar: "العلا" },
  { en: "Al Wajh", ar: "الوجه" },
  { en: "Al Zulfi", ar: "الزلفي" },
  { en: "Anak", ar: "عنك" },
  { en: "Arar", ar: "عرعر" },
  { en: "Ash Shafa", ar: "الشفا" },
  { en: "Asfan", ar: "عسفان" },
  { en: "Badr", ar: "بدر" },
  { en: "Baljurashi", ar: "بلجرشي" },
  { en: "Baqa", ar: "بقعاء" },
  { en: "Bisha", ar: "بيشة" },
  { en: "Buraidah", ar: "بريدة" },
  { en: "Dammam", ar: "الدمام" },
  { en: "Dhahran", ar: "الظهران" },
  { en: "Dhurma", ar: "ضرما" },
  { en: "Farasan", ar: "فرسان" },
  { en: "Fifa", ar: "فيفاء" },
  { en: "Hafar Al Batin", ar: "حفر الباطن" },
  { en: "Hail", ar: "حائل" },
  { en: "Haql", ar: "حقل" },
  { en: "Hawtat Bani Tamim", ar: "حوطة بني تميم" },
  { en: "Jazan", ar: "جازان" },
  { en: "Jeddah", ar: "جدة" },
  { en: "Khamis Mushait", ar: "خميس مشيط" },
  { en: "Khaybar", ar: "خيبر" },
  { en: "Khulais", ar: "خليص" },
  { en: "Layla", ar: "ليلى" },
  { en: "Madinah (Medina)", ar: "المدينة المنورة" },
  { en: "Mahd adh Dhahab", ar: "مهد الذهب" },
  { en: "Makkah (Mecca)", ar: "مكة المكرمة" },
  { en: "Muhayil Aseer", ar: "محايل عسير" },
  { en: "Najran", ar: "نجران" },
  { en: "Nariyah", ar: "النعيرية" },
  { en: "Onaizah", ar: "عنيزة" },
  { en: "Qunfudhah", ar: "القنفذة" },
  { en: "Rafha", ar: "رفحاء" },
  { en: "Ras Tanura", ar: "رأس تنورة" },
  { en: "Riyadh", ar: "الرياض" },
  { en: "Sabya", ar: "صبيا" },
  { en: "Sakaka", ar: "سكاكا" },
  { en: "Sharurah", ar: "شرورة" },
  { en: "Shaqra", ar: "شقراء" },
  { en: "Tabuk", ar: "تبوك" },
  { en: "Taif", ar: "الطائف" },
  { en: "Tanomah", ar: "تنومة" },
  { en: "Turaif", ar: "طريف" },
  { en: "Umluj", ar: "أملج" },
  { en: "Wadi Ad Dawasir", ar: "وادي الدواسر" },
  { en: "Yanbu", ar: "ينبع" },
  { en: "Zulfi", ar: "الزلفي" }
];



const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #f5f5f5;
  border-radius: 12px;
`;

const Label = styled.label`
  font-weight: bold;
`;

const Input = styled.input`
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const Textarea = styled.textarea`
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const Select = styled.select`
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const Button = styled.button`
  padding: 0.8rem;
  background-color: #007bff;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
  }
`;

const Preview = styled.img`
  max-width: 180px;
  margin-top: 1rem;
  border-radius: 6px;
`;

const SmallPreview = styled.img`
  max-width: 120px;
  margin-top: 0.5rem;
  border-radius: 6px;
`;

const NewRealEstate = ({ setUserRealEstate }) => {
  const [estate, setEstate] = useState({
    city: "",
    type: "",
    description: "",
    price: "",
  });

  const [mainImage, setMainImage] = useState(null);
  const [secondaryImages, setSecondaryImages] = useState([]);

  const token = localStorage.getItem("token");

  const handleSecondaryUpload = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const updated = [...secondaryImages];
    updated[index] = file;
    setSecondaryImages(updated);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEstate((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!mainImage) return alert("Please upload the main image");

    try {
      const formData = new FormData();

      Object.entries(estate).forEach(([key, val]) => {
        formData.append(key, val);
      });

      // MAIN IMAGE
      formData.append("img", mainImage);

      // SECONDARY IMAGES
      secondaryImages.forEach((file, index) => {
        formData.append(`img${index + 1}`, file);
      });

      const res = await axios.post(
        "/api/AffordableRealestates",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setUserRealEstate((prev) => [...prev, res.data.realEstate]);
      alert("Real estate added successfully!");

      // Reset form
      setEstate({
        city: "",
        type: "",
        description: "",
        price: "",
      });

      setMainImage(null);
      setSecondaryImages([]);

    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <h2>Add Real Estate Listing</h2>

      <Label>City</Label>
      <Select name="city" value={estate.city} onChange={handleChange} required>
        <option value="">Select City</option>
        {saudiCities.map((c) => (
          <option key={c.en} value={c.en}>
            {c.en} — {c.ar}
          </option>
        ))}
      </Select>

      <Label>Type</Label>
      <Select name="type" value={estate.type} onChange={handleChange} required>
        <option value="">Select Type</option>
        {estateTypes.map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </Select>

      <Label>Description</Label>
      <Textarea
        name="description"
        rows="3"
        value={estate.description}
        onChange={handleChange}
      />

      <Label>Price</Label>
      <Input
        name="price"
        type="number"
        value={estate.price}
        onChange={handleChange}
        required
      />

      {/* MAIN IMAGE */}
      <Label>Main Image</Label>
      <Input type="file" onChange={(e) => setMainImage(e.target.files[0])} required />
      {mainImage && <Preview src={URL.createObjectURL(mainImage)} alt="main" />}

      {/* SECONDARY IMAGES — DYNAMIC */}
      {mainImage && (
        <>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i}>
              {(i === 0 || secondaryImages[i - 1]) && (
                <>
                  <Label>Secondary Image {i + 1}</Label>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleSecondaryUpload(e, i)}
                  />
                  {secondaryImages[i] && (
                    <SmallPreview src={URL.createObjectURL(secondaryImages[i])} />
                  )}
                </>
              )}
            </div>
          ))}
        </>
      )}

      <Button type="submit">Submit Real Estate</Button>
    </Form>
  );
};

export default NewRealEstate;
